import { http, http_v2 } from '@api/client';
import { paramterize, pickResponse, pickResult } from '@api/utils';
import { DealDetail, PersonCompanyRelation} from '@lib/deals';
import {
  DealFilterParams,
  DealMergeRequest,
  DealResult,
  FilterResponse,
  SearchDealsQuery,
  SearchDealsResponse,
} from './types';
import { windowObj } from '@lib/common';

/**
 * Get latest deals or search and get the fitered deals.
 * @param query The query params to pass to the url.
 */
export function search(query: SearchDealsQuery) {
  const params = paramterize(query);
  return http.get<SearchDealsResponse>('/deals', { params }).pipe(pickResponse());
}

/**
 * Get the deal details from the server.
 * @param id The id of the deal to get
 */
export function get(id: string) {
  return http_v2.get<DealResult>(`/deals/${id}`).pipe(pickResult());
  // return of(singleDealResponse);
}

export function getAISummaryURL(promptString :string){
  const base_url = windowObj.RAZZLE_VTR_PINT_BACKEND;
  const ai_summary_prompt_url = base_url+ '/api/v1/cmd/ai_summary'+promptString
  return(ai_summary_prompt_url)
}
/**
 * Filter deals using dynamic operators.
 * @param option Query options
 */
export function filter({
  filters = [],
  pageSize: page_size = 10,
  page = 1,
  sortBy = [],
}: DealFilterParams = {}) {
  const sort = sortBy.map(({ id, desc }) => `${desc ? '$desc' : '$asc'}|||${id}`).join(';');
  const newFilters = updateFiltersForLinkedOperator(filters);
  const filtersMap: Record<string, string> = newFilters.reduce(
    (map, f) =>
      Object.assign(map, {
        [f.id]: Object.entries(f.value)
          .map(([op, v]) => (op === '$bw' ? `$gte|||${v[0]};$lte|||${v[1]}` : `${op}|||${v}`))
          .join(';'),
      }),
    {}
  );

  const params = paramterize({ page_size, page, sort, ...filtersMap });

  return http.get<FilterResponse>('/deals/related', { params }).pipe(pickResponse());
}

/**
 * Merge deals.
 * @param data The merge request model.
 */
export function merge(data: DealMergeRequest) {
  return http.put<DealResult>('/deals/related', data).pipe(pickResponse());
}

/**
 * Updates the given deal.
 * @param deal The deal to update
 */
export function update(deal: Partial<DealDetail>) {
  if (deal?.to_air_on) {
    deal['to_air_on'] = deal?.to_air_on.filter(a => a);

    deal['to_air_on'] = deal['to_air_on'].filter(function (el) {
      return el.vtr_id != '';
    });
  }

  return http_v2.put<DealResult>(`/deals/${deal.id}`, deal).pipe(pickResponse());
}

/**
 * Deletes the given deal.
 * @param deal The deal id or the actual deal.
 */
export function remove(deal: Partial<DealDetail>) {
  return http_v2
    .delete<DealResult>(`/deals/${deal.id}`, {
      data: { id: deal.id, delete_reason: deal.delete_reason },
    })
    .pipe(pickResponse());
}

/**
 * Creates the given deal.
 * @param deal The deal to create
 */
export function create(deal: DealDetail) {
  if (deal?.to_air_on) {
    deal['to_air_on'] = deal?.to_air_on.filter(a => a);

    deal['to_air_on'] = deal['to_air_on'].filter(function (el) {
      return el.vtr_id != '';
    });
  }
  return http_v2.post<DealResult>(`/deals`, deal).pipe(pickResponse());
}

/**
 * Creates person company Relation the given deal.
 * @param deal The deal to create
 */
export function createPersonCompanyRelation(deal: PersonCompanyRelation) {
  return http.post<DealResult>(`/deals/person_validation`, deal).pipe(pickResponse());
}

function updateFiltersForLinkedOperator(filters) {
  let newFilters = JSON.parse(JSON.stringify(filters));
  const mappedDataForLinkedOperator = [];

  newFilters.forEach(eachfilter => {
    const mappedValuesForLinkedOperator = {};
    Object.entries(eachfilter.value).forEach(eachIdOperators => {
      if (eachIdOperators.includes('$linked')) {
        eachIdOperators[0] = '$empty';
        eachIdOperators[1] === 'yes'
          ? (eachIdOperators[1] = 'false')
          : (eachIdOperators[1] = 'true');
        mappedValuesForLinkedOperator[eachIdOperators[0]] = eachIdOperators[1];
        mappedDataForLinkedOperator.push({
          id:
            eachfilter.id === 'entity1'
              ? 'entity1_vtr_id'
              : eachfilter.id === 'entity2'
              ? 'entity2_vtr_id'
              : eachfilter.id === 'content'
              ? 'content_vtr_id'
              : eachfilter.id,
          value: mappedValuesForLinkedOperator,
        });
      }
    });
    if (Object.keys(mappedValuesForLinkedOperator).length) {
      delete eachfilter['value']['$linked'];
    }
  });
  newFilters = [...newFilters, ...mappedDataForLinkedOperator];
  return newFilters;
}
